import { Box, IconButton, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { FileDto, FilesRycApiClient } from '../Api/ApiServer';
import { Delete, Download, Share } from '@mui/icons-material';
import { useApi } from '../Api/useApi';

export interface IFileListItemProps {
    file: FileDto;
    selectedFile: FileDto | null;
    setSelectedFile: (file: FileDto | null) => void;
    fileDownloadUri: string | null;
    onDelete: (file: FileDto) => void;
    onShare: (file: FileDto) => void;
}

export default function FileListItem(props: IFileListItemProps) {
    const { file, selectedFile, setSelectedFile, fileDownloadUri, onDelete, onShare } = props;
    return (
        <Box
            key={file.id}
            textAlign={'left'}
            display='flex'
            justifyContent='space-between'
            alignItems='center'
            sx={{
                border: '1px solid #C3C3C3',
                borderRadius: '4px',
                cursor: 'pointer',
                padding: '4px',
                margin: '4px',
                backgroundColor: selectedFile?.id === file.id ? '#E0E0E0' : 'transparent',
                '&:hover': {
                    backgroundColor: '#D0D0D0'
                }
            }}
            onClick={(e) => {
                e.stopPropagation();
                setSelectedFile(file);
            }}>
            <Typography variant='body2'>{file.name}</Typography>
            <Stack direction='row'>
                <IconButton onClick={() => { onDelete(file) }}><Delete></Delete></IconButton>
                <IconButton onClick={() => { onShare(file) }}><Share /></IconButton>
                <IconButton onClick={
                    async (e) => {
                        e.stopPropagation();
                        if (fileDownloadUri) {
                            const response = await fetch(fileDownloadUri);
                            const blob = await response.blob();
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.style.display = 'none';
                            a.href = url;
                            a.download = file.name!;
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                        }
                    }
                }><Download /></IconButton>
            </Stack>
        </Box>
    );
}
